import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AppState } from '../../../store';
import { withRouter, useHistory } from 'react-router';
import { connect } from 'react-redux';
import { Card, CardActionButton, DynamicForm, TableNew } from '../../elements';
import { CONSTS } from '../../elements/_constants';
import { postCommodity, getCommodity, putCommodity, fetchCommodities } from '../../../store/commodities/functions';
import { Commodity } from '../../../store/commodities/types';
import { useSelector } from 'react-redux';
import { BASE_URL } from '../../../inc/constants';
import Axios from 'axios';
import Link from '../../elements/link';
import moment from 'jalali-moment'
import persify from 'persify'

const NewCommodityComponent = (props) => {
    let history = useHistory();
    const [obj, setObj] = useState();
    const [transactions, setTransactions] = useState([]);
    const token = useSelector(state => state.base.token);

    useEffect(() => {
        if (props.isUpdate) {
            props.onFetchCommodities();
            loadObj();
            loadTransactions();
        };
        return () => { }
    }, []);

    const loadObj = () => {
        var id = props.match.params.id;
        var object = getCommodity(props.commodities, id);
        setObj(object);
    }

    const fields = [
        {
            id: "name",
            label: "نام کالا",
            defaultValue: obj && obj.name,
            htmltype: 'text',
            required: true
        },
        {
            id: "company",
            label: "شرکت سازنده",
            defaultValue: obj && obj.company,
            htmltype: 'text',
            required: true
        },
        {
            id: "order_point",
            htmltype: "number",
            label: "نقطه سفارش",
            defaultValue: obj ? obj.order_point : 0,
            required: true
        },
        {
            id: "stock",
            htmltype: "number",
            label: "موجودی",
            disabled: true,
            defaultValue: obj && obj.trans_stock
        }
    ]
    const handleSubmit = (data) => {
        if (props.isUpdate) {
            props.onUpdateCommodity(props.match.params.id, data, () => {
                history.push('/store');
            });
        } else {
            props.onCreateCommodity(data, () => {
                history.push('/store');
            });
        }

    }

    const columns = [
        {
            title: 'زمان',
            dataIndex: 'timestamp',
            render: t => persify(""+moment(t, 'YYYY-MM-DDTHH:mm:ss').locale('fa').format('YYYY/MM/DD - HH:mm')),
        },
        {
            title: 'تعداد',
            dataIndex: 'count'
        },
        {
            title: 'روش انجام',
            dataIndex: 'method'
        },
        {
            title: 'مقدار مصرف',
            dataIndex: 'dosage'
        },
        {
            title: 'توضیحات',
            dataIndex: 'description'
        },
        {
            title: '',
            dataIndex: 'id',
            style: { width: 50 },
            render: (id) => (
                <Link style={{ color: CONSTS.colors.greyDarker }} to={`/store/transactions/${id}/edit`}>ویرایش</Link>
            )
        }
    ]
    const loadTransactions = () => {
        var id = props.match.params.id;
        const headers = { Authorization: `token ${token}` };
        Axios.get(`${BASE_URL}/store/transactions/?commodity=${id}`, { headers })
            .then(res => {
                setTransactions(res.data);
            })
    }
    return (
        <div className={props.className}>
            <Card
                title={obj ? 'ویرایش کالا' : 'ایجاد کالای جدید'}
                headerMeta={<>
                    <CardActionButton title="بازگشت" to={`/store`} hasBorderRight={true} />
                </>}
            >
                <DynamicForm fields={fields} onSubmit={handleSubmit} />

                <div className="transactions">
                    {obj && <TableNew columns={columns} dataSource={transactions} />}
                </div>
            </Card>
        </div>
    )
}
const NewCommodity = styled(NewCommodityComponent)`
    .transactions{
        direction: rtl;
        padding: 15px;
    }
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
    padding-left: 15px;
    }
`

const mapStateToProps = (state, ownProps) => ({
    commodities: state.commodities.items
});

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onFetchCommodities: () => {
            dispatch(fetchCommodities());
        },
        onCreateCommodity: (data, then) => dispatch(postCommodity(data, then)),
        onUpdateCommodity: (id, data, then) => dispatch(putCommodity(id, data, then)),
    };
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(NewCommodity));
